// extracted by mini-css-extract-plugin
export default {"wrapper":"StepsWrapper_wrapper__7pAVT","columnDirection":"StepsWrapper_columnDirection__3QkKC"};